import createIcon from '../../createIcon';

/**
 * @component @name TurnSharpRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSA2LjgzTDE4LjA5IDguNDJMMTkuNSA3TDE1LjUgM0wxMS41IDdMMTIuOTEgOC40MUwxNC41IDYuODNWMTNINi41QzUuNCAxMyA0LjUgMTMuOSA0LjUgMTVWMjFINi41VjE1SDE0LjVDMTUuNiAxNSAxNi41IDE0LjEgMTYuNSAxM1Y2LjgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnSharpRight = createIcon('TurnSharpRight', [
  [
    'path',
    {
      d: 'M16.5 6.83L18.09 8.42L19.5 7L15.5 3L11.5 7L12.91 8.41L14.5 6.83V13H6.5C5.4 13 4.5 13.9 4.5 15V21H6.5V15H14.5C15.6 15 16.5 14.1 16.5 13V6.83Z',
      key: 'gw3vr5',
    },
  ],
]);

export default TurnSharpRight;
